import { ApolloClient, ApolloLink, createHttpLink, InMemoryCache } from "@apollo/client";
import { onError } from "@apollo/client/link/error";

import { withApolloRetryLink } from "src/authentication/withApolloRetryLink";
import { withAuthMiddleware } from "src/authentication/withAuthMiddleware";
import { withXCSRFToken } from "src/authentication/withXCSRFToken";

const fragmentTypes = {
  ParameterValueSetInterface: ["EnumValueSet", "ListElementsValueSet", "QueryValueSet"],
  kpi: ["MultipleValuesKpi", "SingleValueKpi"],
};

const errorLink = onError(({ operation, response, graphQLErrors }) => {
  if (graphQLErrors) {
    console.error("[GraphQL error]:", { operation, response, graphQLErrors });
  }
});

const apolloClient = new ApolloClient({
  link: ApolloLink.from([
    errorLink,
    withApolloRetryLink(),
    withAuthMiddleware(),
    withXCSRFToken(),
    createHttpLink({ uri: "/reporting-api/v1/graphql" }),
  ]),

  cache: new InMemoryCache({
    possibleTypes: fragmentTypes,
  }),
});

export function getReportingApolloClient() {
  return apolloClient;
}
